import styled from 'styled-components'

export const YourEmploymentStyle = styled.div`
  .autocomplete-info-container {
    display: flex;
    .tip-top-autocomplete {
      top: 19px;
    }
  }
  .auto-complete-container {
    width: 350px;
    background: #fff;
    .input-wrapper {
      width: 100%;
    }
    .auto-complete-input {
      width: 100%;
    }
    .input {
      width: 100%;
    }
  }
`
